<template>
  <div class="wrapper wrapper-full-page page-content update-ride-destination">
    <div class="content">
      <div class="container">
        <el-form
          v-loading="isLoading"
          element-loading-text="Updating Ride Destination..."
          element-loading-custom-class="spinner-class"
          @submit.prevent="submitForm"
        >
          <div class="card">
            <div class="card-header justify-content-center">
              <h3 class="card-title">
                Update Ride Destination
              </h3>
            </div>

            <div
              v-if="isSetupGoogle"
              class="card-content"
            >
              <address-section
                v-model="address"
                :page-id="pageId"
                :show-apt="false"
              />
            </div>

            <div class="card-footer">
              <div class="form-submit-button-group">
                <p-button
                  native-type="submit"
                  type="purple"
                  round
                  class="btn-update-destination"
                >
                  Update Destination
                </p-button>

                <p-button
                  type="yellow"
                  round
                  @click="resetForm"
                >
                  Reset
                </p-button>
              </div>

              <div class="form-description">
                Have some questions? <br class="is-mobile">
                Check out our driver FAQ! <br>
                <a
                  href="https://gogograndparent.com/driverfaq"
                  target="_blank"
                >https://gogograndparent.com/driverfaq</a>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted, ref, Ref, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useSwalDialog } from '@/use/swalDialog';
import { sendPost } from '@/Utils/api';
import { CustomLocationType } from '@/models/address';

const pageId = 'update-ride-destination';

export default {
  setup: () => {
    const route = useRoute();

    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const address: Ref<CustomLocationType> = ref({
      streetAddress: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      latitude: null,
      longitude: null,
    });
    const isLoading = ref(false);
    const isSetupGoogle = ref(false);
    const requestId = ref('');

    const instance: any = getCurrentInstance();

    const initGooglePlaces = async () => {
      try {
        await instance.ctx.$gmapApiPromiseLazy();
        isSetupGoogle.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const submitForm = async () => {
      isLoading.value = true;
      try {
        await sendPost('driverUpdateRideDestination', {
          requestId: requestId.value,
          streetAddress: address.value.streetAddress,
          city: address.value.city,
          state: address.value.state,
          zip: address.value.zip,
          latitude: address.value.latitude,
          longitude: address.value.longitude,
        });

        showSuccessPopupDialog({
          text: 'The destination has been updated successfully.',
        });
      } catch (error) {
        const errorText = util.getErrorResponse(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      address.value = {
        streetAddress: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        latitude: null,
        longitude: null,
      };
    };

    onMounted(() => {
      initGooglePlaces();

      requestId.value = route.params.requestId as string;
    });

    return {
      pageId,
      address,
      isLoading,
      isSetupGoogle,

      submitForm,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
.update-ride-destination {
  background: #638842;

  .container {
    padding-top: 100px;
  }

  .card-title {
    color: #965c05 !important;
    font-weight: bold !important;
    padding-bottom: 10px;
  }

  .form-submit-button-group {
    display: flex;
    justify-content: center;

    .btn-update-destination {
      margin-right: 15px !important;
    }
  }

  .form-description {
    margin-top: 20px;
    color: #252422;
    font-weight: 500;
    text-align: center;

    a {
      color: #00f;
    }
  }
}
</style>
